// Query-string flags both glasses clients read, kept in one place so a flag
// name only ever needs to change here. Nothing here reads `location` or
// `window` at module top level: every function takes the search string in.

/** The theme this page run draws with when no "?theme=" is given. */
export const DEFAULT_THEME_KEY = 'mu-agency';

/** True when the query string carries the boolean flag "?<name>=1". */
export function flagEnabled(search: string, name: string): boolean {
  return new URLSearchParams(search).get(name) === '1';
}

/** Reads the theme key from a query string, for example "?theme=mu-terminal". */
export function themeKeyFromSearch(search: string): string {
  const key = new URLSearchParams(search).get('theme');
  return key && key.trim() !== '' ? key : DEFAULT_THEME_KEY;
}

/**
 * True when the query string carries "?speech=real". Under "?fake=1" this
 * swaps the scripted speech ports back for the real microphone, speech-to-text,
 * text-to-speech, and playback ports, while the rest of "?fake=1" stays scripted.
 */
export function speechRealEnabled(search: string): boolean {
  return new URLSearchParams(search).get('speech') === 'real';
}

/**
 * True when the query string carries "?resume=1". By default every page
 * load starts a fresh run against the gateway with a fresh device id, so
 * the opening line is never silently skipped by a resumed run. "?resume=1"
 * restores the old behaviour: the stored, stable per-install device id.
 */
export function resumeEnabled(search: string): boolean {
  return new URLSearchParams(search).get('resume') === '1';
}
